if (!customElements.get('st-review-carousel')) {
  customElements.define('st-review-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.viewport = this.querySelector('.sr-viewport');
      this.track = this.querySelector('.sr-track');
      this.dialog = this.querySelector('dialog');
      this.originals = [...this.track.children];
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.touchHeld = false;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.viewport.addEventListener('touchstart', () => {
        this.touchHeld = true;
      }, {passive:true, signal});
      const releaseTouch = event => {
        this.touchHeld = event.touches.length > 0;
        this.position = this.viewport.scrollLeft;
        this.lastWritten = this.viewport.scrollLeft;
      };
      window.addEventListener('touchend', releaseTouch, {passive:true, signal});
      window.addEventListener('touchcancel', releaseTouch, {passive:true, signal});
      window.addEventListener('blur', () => { this.touchHeld = false; }, {signal});
      this.originals.forEach(card => {
        const clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('button').forEach(button => button.tabIndex = -1);
        this.track.append(clone);
      });
      this.measure = () => {
        this.cycle = this.track.children[this.originals.length].offsetLeft - this.track.children[0].offsetLeft;
        this.position = this.viewport.scrollLeft;
      };
      this.resize = new ResizeObserver(this.measure);
      this.resize.observe(this.viewport);
      this.viewport.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.viewport.scrollLeft += (event.key === 'ArrowRight' ? 1 : -1) * 300;
          this.position = this.viewport.scrollLeft;
        }
      }, {signal});
      this.track.addEventListener('click', event => {
        const button = event.target.closest('.sr-more');
        if (!button) return;
        this.dialog.querySelector('h3').textContent = button.dataset.author;
        this.dialog.querySelector('p').textContent = button.dataset.review;
        this.returnFocus = button;
        this.dialog.showModal();
      }, {signal});
      this.dialog.querySelector('.sr-close').addEventListener('click', () => this.dialog.close(), {signal});
      this.dialog.addEventListener('close', () => { if (this.returnFocus) this.returnFocus.focus({preventScroll:true}); }, {signal});
      this.measure();
      const tick = time => {
        const elapsed = this.lastTime ? Math.min(time - this.lastTime, 50) : 0;
        this.lastTime = time;
        if (!this.motion.matches && !this.touchHeld && this.cycle && !document.hidden) {
          if (this.lastWritten !== undefined && Math.abs(this.viewport.scrollLeft - this.lastWritten) > 2) this.position = this.viewport.scrollLeft;
          this.position += elapsed * Number(this.dataset.speed || 20) / 1000;
          if (this.position >= this.cycle) this.position %= this.cycle;
          this.viewport.scrollLeft = this.position;
          this.lastWritten = this.viewport.scrollLeft;
        } else this.position = this.viewport.scrollLeft;
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.abort?.abort(); this.resize?.disconnect();
      [...this.track.children].slice(this.originals.length).forEach(card => card.remove());
      this.ready = false;
    }
  });
}
